import { compose } from 'redux';
import { connect } from 'react-redux';
import { LocalizedText } from '@mews/framework';
import { TextKey } from '@mews-commander/enums';
import { CommanderThunkDispatch } from '@mews-commander/types';
import { commanderForm, validation, FileForm, fileFormConstraints } from '@mews-commander/legacy-form';
import { processFile } from '../../actions/import';

interface OwnProps {
    form: string;
    accept: string;
}

export default compose<React.FC<OwnProps>>(
    connect(undefined, (dispatch: CommanderThunkDispatch, { form }) => ({
        onSubmit: (values: { files: FileList }) => dispatch(processFile(values, form)),
    })),
    commanderForm({
        enableReinitialize: true,
        submitLabel: <LocalizedText textKey={TextKey.Import} />,
        validate: validation(fileFormConstraints),
        submitButtonProps: { variant: 'primary' },
    })
)(FileForm);
